import { ReactNode } from 'react'

import './rectangle.scss'

export interface RectangleProps {
  children: ReactNode
}

export const Rectangle = (props: RectangleProps) => {
  const { children } = props
  return <div className="rectangle">{children}</div>
}
